module.exports = __webpack_public_path__ + "static/p09_pajaroLvolando-56de075eac8f7e1f7a99bcba850d18f5.png";